enum Competence {
  EAU = "EAU",
  ASS = "ASS",
  GCE = "GCE",
  GEPU = "GEPU",
}

export default Competence;
